// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__qy0UD","tooltip__title":"tooltip_tooltip__title__EtLkN","triangle":"tooltip_triangle__8-Egi"};